import { z } from "zod"

export const KlaviyoIntegrationResponseDataSchema = z.object({
  apiKey: z.string().optional(),
})
